"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const formik_1 = require("formik");
const InputField_1 = __importDefault(require("../../forms/InputField"));
const Button_1 = __importDefault(require("../../forms/Button"));
const react_router_dom_1 = require("react-router-dom");
const api_1 = require("../../api");
const errorNotification_1 = require("../../errorNotification");
const react_helmet_1 = __importDefault(require("react-helmet"));
const AddEdit = ({ history, match, ...props }) => {
    const { id } = match.params;
    const isAddMode = !id;
    const companyApi = new api_1.CompanyApi();
    let initialValues = {
        name: '',
        short_name: '',
        address: '',
        postal_code: '',
        location: '',
        country: '',
        email_address: '',
        phone_number: '',
        uid: '',
        floramedia_customer_number: '',
    };
    function onSubmit(fields, { setErrors, setStatus, setSubmitting }) {
        setStatus();
        if (isAddMode) {
            create(fields, setSubmitting, setErrors);
        }
        else {
            update(id, fields, setSubmitting, setErrors);
        }
    }
    function create(fields, setSubmitting, setErrors) {
        companyApi.create(fields)
            .then(() => {
            (0, errorNotification_1.notify)('success', 'Firma erstellt.');
            history.push('.');
        })
            .catch((error) => {
            if (error.response.status === 422) {
                setErrors(error.response.data.errors);
            }
            else {
                (0, errorNotification_1.notifyError)(error.response.data.message);
            }
            setSubmitting(false);
        });
    }
    function update(id, fields, setSubmitting, setErrors) {
        companyApi.update(id, fields)
            .then(() => {
            (0, errorNotification_1.notify)('success', 'Firma aktualisiert.');
            history.push('..');
        })
            .catch(error => {
            if (error.response.status === 422) {
                setErrors(error.response.data.errors);
            }
            else {
                (0, errorNotification_1.notifyError)(error.response.data.message);
            }
            setSubmitting(false);
        });
    }
    return (react_1.default.createElement("div", { className: "container max-w-5xl" },
        react_1.default.createElement(react_helmet_1.default, null,
            react_1.default.createElement("title", null, isAddMode ? 'Neue Firma' : 'Firma')),
        react_1.default.createElement("div", { className: "flex-1 min-w-0 my-4" },
            react_1.default.createElement("h2", { className: "text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:truncate" }, isAddMode ? 'Neue Firma' : 'Firma')),
        react_1.default.createElement("div", { className: "" },
            react_1.default.createElement("div", { className: "shadow sm:rounded-md sm:overflow-hidden" },
                react_1.default.createElement("div", { className: "bg-white py-6 px-4 sm:p-6" },
                    react_1.default.createElement(formik_1.Formik, { initialValues: initialValues, onSubmit: onSubmit }, ({ values, isSubmitting, setFieldValue }) => {
                        const [item, setItem] = (0, react_1.useState)({});
                        (0, react_1.useEffect)(() => {
                            if (!isAddMode) {
                                // get user and set form fields
                                companyApi.get(id).then((data) => {
                                    const { item } = data;
                                    for (const [key, value] of Object.entries(item)) {
                                        setFieldValue(key, value);
                                    }
                                    setItem(item);
                                });
                            }
                        }, []);
                        return (react_1.default.createElement(formik_1.Form, null,
                            react_1.default.createElement("div", { className: 'space-y-6' },
                                react_1.default.createElement(InputField_1.default, { name: "name", type: "text", label: "Firmenname", placeholder: "Firmenname" }),
                                react_1.default.createElement(InputField_1.default, { name: "short_name", type: "text", label: "Firmen-Kurzbezeichnung", placeholder: "" }),
                                react_1.default.createElement(InputField_1.default, { name: "address", type: "text", label: "Stra\u00DFe", placeholder: "Straße" }),
                                react_1.default.createElement(InputField_1.default, { name: "postal_code", type: "text", label: "Postleitzahl", placeholder: "Postleitzahl" }),
                                react_1.default.createElement(InputField_1.default, { name: "location", type: "text", label: "Ort", placeholder: "Ort" }),
                                react_1.default.createElement(InputField_1.default, { name: "country", type: "text", label: "Land", placeholder: "Land" }),
                                react_1.default.createElement(InputField_1.default, { name: "phone_number", type: "text", label: "Telefonnummer", placeholder: "Telefonnummer" }),
                                react_1.default.createElement(InputField_1.default, { name: "email_address", type: "text", label: "E-Mail", placeholder: "E-Mail" }),
                                react_1.default.createElement(InputField_1.default, { name: "uid", type: "text", label: "Umsatzsteueridentifikationsnummer (UID-Nummer)", placeholder: "UID-Nummer" }),
                                react_1.default.createElement(InputField_1.default, { name: "floramedia_customer_number", type: "text", label: "Floramedia Kundennummer", placeholder: "Floramedia Kundennummer" }),
                                react_1.default.createElement(Button_1.default, { type: "submit", size: 'md', disabled: isSubmitting }, "Speichern"),
                                react_1.default.createElement(react_router_dom_1.Link, { to: `/companies`, className: "ml-4 link-button --secondary" }, "Abbrechen"))));
                    }))))));
};
exports.default = AddEdit;
